import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { SelectModule } from 'ng-select';
import {BsDatepickerModule, TooltipModule} from 'ngx-bootstrap';
import {BoxRetalStampsTHComponent} from './boxRetalStampsTH.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    BsDatepickerModule.forRoot(),
    TooltipModule,
    TranslateModule,

  ],
  exports: [
    BoxRetalStampsTHComponent
  ],
  declarations: [BoxRetalStampsTHComponent]
})
export class BoxRetalStampsTHModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/share/boxRetalStampsTH/boxRetalStampsTH.module.ts